// extracted by mini-css-extract-plugin
module.exports = {"container":"SubHeaderItem_container__2uuN0","text":"SubHeaderItem_text__EuHt9"};